import { render, staticRenderFns } from "./FreeEntryFlag.vue?vue&type=template&id=09d4fb08&"
import script from "./FreeEntryFlag.vue?vue&type=script&lang=ts&"
export * from "./FreeEntryFlag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports